angular.module('iw.frontyard.repayment_calculator')
    .service('RepaymentScheduler', function (MathHelper) {

        class RepaymentScheduler {

            constructor(siteCode, simpleRates, feeRate) {
                this.siteCode = siteCode;
                this.totalAmount = null;
                this.totalInterestRate = null;
                this.totalFeesAmount = null;
                this.totalInterestAmount = null;
                this.totalRepayment = null;
                this.repayments = [];
                this.feeRate = feeRate;
                this.simpleRates = simpleRates;
                this.interval = 30;
                this.currencyDigits = siteCode === 'pl' || siteCode === 'de' ? 2 : 0;
            }

            calculateSchedule(amount, duration, rate) {
                switch (this.siteCode) {
                    case 'pl':
                        return this.schedulePL(amount, duration, rate);
                    case 'de':
                        return this.scheduleDE(amount, duration, rate);
                    default:
                        return this.scheduleUK(amount, duration, rate);
                }
            }

            scheduleUK(amount, duration, rate) {
                this.totalAmount = amount;
                this.totalInterestRate = (((duration * 0.5) + 0.5) * rate);
                this.totalInterestAmount = ((this.totalInterestRate / 100) * amount);
                this.totalRepayment = this.totalInterestAmount + amount;
                this.repayments.length = 0;
                for (let i = 0; i < duration; i++) {
                    var row = {};
                    var intervalAmount = amount / duration;
                    var intervalInterest = (amount - (intervalAmount * i)) * (rate / 100);
                    intervalAmount = intervalAmount;
                    intervalInterest = intervalInterest;
                    row = {
                        'date': i + 1,
                        'amount': Math.round(intervalAmount),
                        'interest': Math.round(intervalInterest),
                        'total': Math.round(intervalAmount + intervalInterest),
                    };
                    this.repayments[i] = row;
                }
            }

            schedulePL(amount, duration, rate) {
                var outstandingPrincipal = amount;
                var simpleRate = this.simpleRates[duration - 1];
                var simpleRateInterval = simpleRate / duration;

                this.totalAmount = amount;
                this.totalRepayment = MathHelper.round(amount * simpleRate);
                this.totalInterestAmount = 0;
                this.totalFeesAmount = 0;
                this.repayments = [];

                for (let i = 0; i < duration; i++) {
                    var row = {};
                    var total = amount * simpleRateInterval;
                    var fees = MathHelper.round(outstandingPrincipal * this.feeRate);
                    var intervalInterest = MathHelper.round((outstandingPrincipal * rate) / 100);
                    var intervalAmount = MathHelper.round(total - (fees + intervalInterest));
                    this.totalInterestAmount = MathHelper.round(this.totalInterestAmount + intervalInterest);
                    this.totalFeesAmount += fees;
                    outstandingPrincipal -= intervalAmount;
                    row = {
                        'date': i + 1,
                        'amount': duration === 1 ? amount : intervalAmount,
                        'fees': fees,
                        'interest': intervalInterest,
                        'total': MathHelper.round(total),
                    };
                    this.repayments[i] = row;
                }
            }

            scheduleDE(amount, duration, rate) {
                var outstandingPrincipal = amount;
                var simpleRate = this.simpleRates[duration - 1];
                var simpleRateInterval = simpleRate / duration;

                this.totalAmount = amount;
                this.totalRepayment = amount * simpleRate;
                this.totalInterestAmount = 0;
                this.repayments = [];

                for (let i = 0; i < duration; i++) {
                    var row = {};
                    var total = amount * simpleRateInterval;
                    var intervalInterest = (outstandingPrincipal * rate) / 100;
                    var intervalAmount = total - intervalInterest;
                    this.totalInterestAmount += intervalInterest;
                    outstandingPrincipal -= intervalAmount;
                    row = {
                        'date': i + 1,
                        'amount': duration === 1 ? amount : intervalAmount,
                        'interest': intervalInterest,
                        'total': total,
                    };
                    this.repayments[i] = row;
                }
            }
        }

        return RepaymentScheduler;
    });
